import { useContext } from 'react';
import { ActionIcon, Group, Menu, Tooltip } from '@mantine/core';

import { MenuMappingContext } from 'components/MenuManagement/MenuEdit/MenuMapping/MenuMapping';

import { DEFAULT_MODIFIERS, SHOW_DEFAULT_MODIFIERS } from 'constants/mapping';
import { CloseCircleIconSm, EditIconSm, PlusCircleIconSm } from '@chownow/pantry/icons';
import ActionMenu from './ActionMenu';
import { Item } from './types';

interface ActionButtonsProps {
  isModifierSelected?: boolean;
  row: Item;
}

export default function RowActions({ isModifierSelected, row }: ActionButtonsProps) {
  const { checkedItems, setDefaultMods } = useContext(MenuMappingContext);

  const isDisabled = !!checkedItems?.control;
  const disabledTooltip = 'Please use the edit menu to control actions';

  const defaultModsButton =
    row[DEFAULT_MODIFIERS]?.length || row?.[SHOW_DEFAULT_MODIFIERS] ? (
      <Tooltip
        label={isDisabled ? disabledTooltip : 'Remove POS modifiers'}
        position="left"
        w="auto"
      >
        <ActionIcon
          size="xs"
          onClick={() => setDefaultMods({ rowKey: row?.key, value: null })}
          disabled={isDisabled}
          variant="ghost"
        >
          <CloseCircleIconSm />
        </ActionIcon>
      </Tooltip>
    ) : (
      <Tooltip label={isDisabled ? disabledTooltip : 'Add POS modifiers'} position="left" w="auto">
        <ActionIcon
          size="xs"
          onClick={() => setDefaultMods({ rowKey: row?.key, value: [] })}
          disabled={isDisabled}
          variant="ghost"
        >
          <PlusCircleIconSm />
        </ActionIcon>
      </Tooltip>
    );

  const editButton = (
    <ActionIcon size="xs" disabled={isDisabled} variant="ghost" aria-label="Edit mapping">
      <EditIconSm />
    </ActionIcon>
  );

  return (
    <Group wrap="nowrap" gap="xs3">
      <Menu position="left">
        <Menu.Target>
          <Tooltip disabled={!isDisabled} label={disabledTooltip} position="left" w="auto">
            {editButton}
          </Tooltip>
        </Menu.Target>
        <ActionMenu rowKey={row?.key} isModifierSelected={isModifierSelected} />
      </Menu>
      {!isModifierSelected && defaultModsButton}
    </Group>
  );
}
